import React from "react";
import { Routes as RouterRoutes, Route, Navigate, useLocation } from "react-router-dom";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { protectedRoutes, publicRoutes, publicShareRoute } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import PublicShareRoute  from './PublicShareRoute';
import GroupInviteRedirect from "./GroupInviteRedirect";
import ChatModal from "views/app-views/chat-erp/ChatModal";
import useBackgroundLocation, { CHAT_PATH } from "utils/hooks/useBackgroundLocation";

const Routes = () => {
  // Nut chat dieu huong sang /app/chat-erp kem state.backgroundLocation = trang dang mo.
  // Co trang nen -> lop duoi render theo URL trang do (ERP giu nguyen), con chat mount o
  // RouterRoutes thu hai theo URL that nen route con cua ChatModule van khop.
  const location = useLocation();
  const backgroundLocation = useBackgroundLocation();

  return (
    <>
    <RouterRoutes location={backgroundLocation || location}>
      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Navigate replace to={AUTHENTICATED_ENTRY} />}
        />
        {protectedRoutes.map((route, index) => {
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
        <Route path="/g/:code" element={<GroupInviteRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/" element={<PublicShareRoute />}>
        {publicShareRoute.map((route, index) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route, index) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
    </RouterRoutes>

    {backgroundLocation && (
      <RouterRoutes>
        <Route
          path={`${CHAT_PATH}/*`}
          element={<ChatModal background={backgroundLocation} />}
        />
      </RouterRoutes>
    )}
    </>
  );
};

export default Routes;